import React from 'react';
import styled from 'styled-components';
import Menu from './Menu';

const MobileMenuWrapper = styled.div`
  position: fixed;
  top: 0;
  left: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
  height: 100%;
  width: 80%;
  max-width: 300px;
  background-color: #fff;
  transition: left 0.3s ease-in-out;
  z-index: 1000;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);

  @media (min-width: 992px) {
    display: none;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  z-index: 999;
`;

const MenuTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
`;

const MenuInner = styled.div`
  padding: 0 20px;
`;

const MobileMenu = ({ isOpen, onClose }) => {
  return (
    <>
      <Overlay isOpen={isOpen} onClick={onClose} />
      <MobileMenuWrapper isOpen={isOpen}>
        <MenuTitle>
          My Menu
          <CloseButton onClick={onClose}>×</CloseButton>
        </MenuTitle>
        <MenuInner>
          <Menu isMobile={true} toggleMobileMenu={onClose} />
        </MenuInner>
      </MobileMenuWrapper>
    </>
  );
};

export default MobileMenu;